// src/common/components/AuthShell.js
import React from "react";
import Wordmark from "./Wordmark";

export function AuthAlert({ type = "error", children }) {
  const styles =
    type === "success"
      ? "border-emerald-200 bg-emerald-50 text-emerald-700"
      : "border-rose-200 bg-rose-50 text-rose-700";

  return (
    <div className={`rounded-lg border px-4 py-3 text-sm font-medium ${styles}`} role="alert">
      {children}
    </div>
  );
}

export default function AuthShell({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="auth-shell">
      <section className="relative hidden overflow-hidden px-10 py-12 lg:flex lg:flex-col lg:justify-between">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,58,32,0.28),transparent_34%),radial-gradient(circle_at_80%_10%,rgba(148,163,184,0.16),transparent_28%)]" />
        <div className="relative z-10 flex items-center gap-3">
          <Wordmark className="text-2xl" vdoColor="#ffffff" />
        </div>

        <div className="relative z-10 max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            Private preview to public launch
          </p>
          <h1 className="mt-5 text-5xl font-semibold tracking-tight text-white">
            Ship polished video pages without rebuilding the experience.
          </h1>
          <p className="mt-5 max-w-lg text-base leading-7 text-slate-300">
            Create a page, add brand details, protect access when needed, and publish a clean URL for your audience.
          </p>
        </div>

        <div className="relative z-10 grid grid-cols-3 gap-3 text-sm text-slate-300">
          {[
            "Private previews",
            "Custom page URLs",
            "Password gates",
          ].map((item) => (
            <div key={item} className="rounded-lg border border-white/10 bg-white/5 p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]">
              {item}
            </div>
          ))}
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card">
          <div className="mb-8">
            <p className="section-eyebrow">{eyebrow}</p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">
              {title}
            </h2>
            {subtitle && (
              <p className="mt-2 text-sm leading-6 text-slate-600">{subtitle}</p>
            )}
          </div>
          {children}
          {footer && <div className="mt-7 border-t border-slate-200 pt-6 text-center text-sm text-slate-600">{footer}</div>}
        </div>
      </section>
    </div>
  );
}
